import { createStore } from "vuex";
import storage from "@/utils/storage";
const language = storage.getStorage("lang") ? storage.getStorage("lang") : "en";
export default createStore({
  state: {
    lang: language,
    spinning:false,
    pathUrl: "https://www.blixent.com/prod-api/",
  },
  getters: {},
  mutations: {
    TOGGLE_LANG(state, payLoad) {
      state.lang = payLoad;
      storage.setStorage("lang", payLoad);
    },
    START_LOADING(state,spinType) {
      state.spinning = spinType;
    },
  },
  actions: {
    toggleLang({ commit }, payLoad) {
      commit("TOGGLE_LANG", payLoad);
    },
    stopLoading({ commit },spinType) {
      commit("START_LOADING",spinType);
    },
  },
  modules: {},
});
